import React, {useContext, useMemo} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {AuthContext} from "../../../shared/contexts/authContext";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {useItemKrTextData} from "../../probability/useItemData";
import {getItemName} from "../../../shared/utils/basic";
import {fromUnixTimeFormat} from "../../../shared/utils/dayjsUtil";

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString) ?? {};
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

// payType 'Costume' 은 코스튬 idx, 그 외(StepItem 등)는 일반 아이템 idx
const COSTUME_ITEM_TYPE = 24;
const COMMON_ITEM_TYPE = 1;

const PlayerCostumePurchaseLog = () => {
    const {playerData} = useContext(PlayerContext);
    const {currentUser} = useContext(AuthContext);
    const {data: krItemTextData} = useItemKrTextData();

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        pid: playerData.pid,
        logType: 'RQEventExchangeShopLog',
        isUnix: true
    };

    const columns = useMemo(() => [
        {
            title: '지불 타입',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).payType,
        },
        {
            title: '지불 금액',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).payCost,
        },
        {
            title: '구매 아이템',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {payType, itemId} = parseLogData(logString, record);
                if (itemId === undefined || itemId === null || itemId === '') return '';
                const itemType = payType === 'Costume' ? COSTUME_ITEM_TYPE : COMMON_ITEM_TYPE;
                const name = getItemName(krItemTextData?.[currentUser.target] || [], itemId, itemType);
                return `${name}(${itemId})`;
            },
        },
        {
            title: '구매 개수',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).itemQuantity,
        },
        {
            title: '트리거 시간',
            dataIndex: 'created',
            render: (created) => created ? fromUnixTimeFormat(created) : '',
        },
    ], [krItemTextData, currentUser.target]);

    return (
        <div>
            <LogTemplate
                columns={columns}
                defaultSearchParams={defaultSearchParams}
                routerUrl={'/logs/operation'}
                logName={'CostumePurchaseLog'}
                log={'operation'}
            />
        </div>
    );
};

export default PlayerCostumePurchaseLog;
